import React from 'react';
import { FaFolder, FaExternalLinkAlt, FaCopy, FaCheck, FaEdit, FaTrash } from 'react-icons/fa';
import { getBaseUrl } from '../utils/tokenUtils';

const ShortLinkInfo = ({ 
  analytics, 
  copied, 
  onCopy, 
  onEdit, 
  onDelete, 
  onOpenLink 
}) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="mb-8">
      <div className="flex items-start lg:items-center justify-between">
        <div className="flex items-center space-x-4 flex-1 min-w-0 pr-2">
          <div className="flex items-center space-x-3">
            {analytics?.shortLink?.projectLogo ? (
              <img 
                src={analytics.shortLink.projectLogo.startsWith('http') ? analytics.shortLink.projectLogo : `${getBaseUrl()}${analytics.shortLink.projectLogo}`}
                alt="Project Logo" 
                className="h-10 w-10 lg:h-12 lg:w-12 rounded-xl object-cover border border-gray-600"
                onError={(e) => {
                  e.target.style.display = 'none';
                  if (e.target.nextSibling) {
                    e.target.nextSibling.style.display = 'flex';
                  }
                }}
              />
            ) : null}
            <div 
              className="h-10 w-10 lg:h-12 lg:w-12 bg-gray-800 rounded-xl flex items-center justify-center"
              style={{ display: analytics?.shortLink?.projectLogo ? 'none' : 'flex' }}
            >
              <FaFolder className="w-5 h-5 lg:w-6 lg:h-6 text-gray-300" />
            </div>
            <div className="text-left">
              <div className="flex flex-col lg:flex-row lg:items-center space-y-1 lg:space-y-0 lg:space-x-2">
                <h2 className="text-lg lg:text-2xl font-bold text-white text-left">
                  {analytics?.shortLink?.title || analytics?.shortLink?.shortCode || 'Short Link'}
                </h2>
                <span className="hidden lg:inline text-gray-400">•</span>
                <span className="text-sm lg:text-base text-gray-400 text-left">
                  {analytics?.shortLink?.createdAt ? formatDate(analytics.shortLink.createdAt) : ''}
                </span>
              </div>
              <p className="text-sm text-gray-400 text-left">
                <span className="text-gray-400">{getBaseUrl()}/s/</span>
                <span className="text-white font-bold text-base lg:text-lg">{analytics?.shortLink?.shortCode}</span>
              </p>
            </div>
          </div>
        </div>
        
        <div className="flex items-center space-x-3">
          <button
            onClick={onCopy}
            className="flex items-center px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors border border-gray-700"
          >
            {copied ? (
              <FaCheck className="mr-2 h-4 w-4 text-green-400" />
            ) : (
              <FaCopy className="mr-2 h-4 w-4" />
            )}
            {copied ? 'Copied' : 'Copy'}
          </button>
          
          <button
            onClick={onOpenLink}
            className="flex items-center px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors border border-gray-700"
          >
            <FaExternalLinkAlt className="mr-2 h-4 w-4" />
            Open
          </button>
          
          <button
            onClick={onEdit}
            className="flex items-center px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors border border-gray-700"
          >
            <FaEdit className="mr-2 h-4 w-4" />
            Edit
          </button>
          
          <button
            onClick={onDelete}
            className="flex items-center px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-red-600 transition-colors border border-gray-700"
          >
            <FaTrash className="mr-2 h-4 w-4" />
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShortLinkInfo;
